/**
 * Convert a hex color "#RRGGBB" into an HSL string "h s% l%" suitable for
 * being passed to the CSS `hsl()` function with our token format.
 *
 * Returns null if input is not a valid hex.
 */
export function hexToHslString(hex) {
  if (!hex || typeof hex !== "string") return null;
  const m = /^#([0-9a-f]{6})$/i.exec(hex.trim());
  if (!m) return null;

  const r = parseInt(m[1].slice(0, 2), 16) / 255;
  const g = parseInt(m[1].slice(2, 4), 16) / 255;
  const b = parseInt(m[1].slice(4, 6), 16) / 255;

  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  const l = (max + min) / 2;
  let h = 0;
  let s = 0;
  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r: h = ((g - b) / d + (g < b ? 6 : 0)); break;
      case g: h = ((b - r) / d + 2); break;
      case b: h = ((r - g) / d + 4); break;
      default: break;
    }
    h *= 60;
  }
  return `${Math.round(h)} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
}

/**
 * Lighten an HSL string by an absolute lightness delta (clamped 0..100).
 * Used to derive a dark-mode variant of the user's custom accent color.
 */
export function lightenHsl(hslString, deltaL = 12) {
  if (!hslString) return null;
  const m = /^(\d+)\s+(\d+)%\s+(\d+)%$/.exec(hslString);
  if (!m) return hslString;
  const h = m[1];
  const s = m[2];
  const l = Math.max(0, Math.min(100, parseInt(m[3], 10) + deltaL));
  return `${h} ${s}% ${l}%`;
}
